import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
} from "reactstrap";

/**
 * Blocked Coupon View Form Component
 */
const BlockedCouponViewForm = ({
    coupon,
    updated_at,
    onInputChange,
    onSubmit,
}) => {
    return (
        <Form onSubmit={onSubmit}>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-store_domain-Input"
                    className="col-sm-1 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Coupon
                </Label>
                <Col sm={3}>
                    <Input
                        value={coupon}
                        type="text"
                        name="coupon"
                        className="form-control"
                        placeholder="Please write blocked coupon"
                        id="horizontal-store_domain-Input"
                        onChange={onInputChange}
                        required={true}
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row justify-content-end">
                <Col sm={updated_at ? 8 : 11}>
                    <div>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                        >
                            Save
                        </Button>
                    </div>
                </Col>
                {updated_at && (
                    <Col sm={3}>
                        <div style={{ textAlign: "right" }}>
                            <Button
                                type="button"
                                color="dark"
                                outline={false}
                            >
                                Last Updated: {updated_at}
                            </Button>
                        </div>
                    </Col>
                )}
            </FormGroup>
        </Form>
    );
};

BlockedCouponViewForm.propTypes = {
    coupon: PropTypes.string.isRequired,
    updated_at: PropTypes.string,
    onInputChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default BlockedCouponViewForm;

